export type HandledErrorType =
	| 'NO_CONFLUENCE_SITE_FOUND_ERROR'
	| 'COULD_NOT_FIND_CONFLUENCE_SITE_ERROR';
export const ERRORS: HandledErrorType[] = [
	'NO_CONFLUENCE_SITE_FOUND_ERROR',
	'COULD_NOT_FIND_CONFLUENCE_SITE_ERROR',
];

export const isHandledErrorType = (str: string): str is HandledErrorType => {
	return ERRORS.includes(str as any);
};

export const getErrorType = (error: unknown) => {
	return error instanceof Error && isHandledErrorType(error.name) ? error.name : 'UNEXPECTED_ERROR';
};

export class UserPermissionError extends Error {
	constructor(public description: string) {
		super(description);
		this.name = 'UserPermissionError';
	}
}

export class NotFoundError extends Error {
	constructor(public description: string) {
		super(description);
		this.name = 'NotFoundError';
	}
}

export class PageTitleError extends Error {
	constructor(public description: string) {
		super('A page with this title already exists');
		this.name = 'PageTitleError';
	}
}

export class TemplateError extends Error {
	constructor(public description: string) {
		super('The template ID does not exist or the user has no permissions to view it');
		this.name = 'TemplateError';
	}
}

export class WhiteboardDuplicateTitleError extends Error {
	constructor(public description: string) {
		super(description);
		this.name = 'WhiteboardDuplicateTitleError';
	}
}

export class NoWhiteboardBetaAccessError extends Error {
	constructor(public description: string) {
		super(description);
		this.name = 'NoWhiteboardBetaAccessError';
	}
}

export class ContentTooLargeError extends Error {
	constructor(public description: string) {
		super(description);
		this.name = 'ContentTooLargeError';
	}
}

export class ADFConversionError extends Error {
	constructor(public description: string) {
		super('Error converting ADF to storage format');
		this.name = 'ADFConversionError';
	}
}
